<script lang="ts">
    import { Router, Route, links } from "svelte-routing"
    // @ts-ignore
    import { scrollToTop } from "svelte-scrollto"
    import { checkIfFollowUpEntriesOverdue, postLogin, postLogout } from "../api"
    import {
        login,
        location,
        newNotification,
        pageScroll,
        openModal,
        rerender,
        followUpMap,
        logoutInSeconds,
        accessTokenExpireSeconds,
    } from "../store"
    import AccountData from "./routes/AccountData.svelte"
    import AccountRequest from "./routes/AccountRequest.svelte"
    import Login from "./routes/Login.svelte"
    import Operations from "./routes/Operations.svelte"
    import OperationsOut from "./routes/OperationsOut.svelte"
    import AccountPwChange from "./routes/AccountPwChange.svelte"
    import Start from "./routes/Start.svelte"
    import Notifications from "./widgets/Notifications.svelte"
    import AccountPwReset from "./routes/AccountPwReset.svelte"
    import { clickOutside, gotoWithLogin, navigateTo } from "../helper"
    import { _ } from "svelte-i18n"
    import {
        mdiAccountCircle,
        mdiLock,
        mdiCardAccountDetailsOutline,
        mdiLogin,
        mdiLogout,
        mdiFileDocumentEditOutline,
        mdiCalculator,
        mdiAccountArrowLeft,
        mdiContacts,
        mdiViewDay,
        mdiKey,
    } from "@mdi/js"
    import Icon from "./widgets/Icon.svelte"
    import Overlay from "./widgets/Overlay.svelte"
    import Content from "./routes/Content.svelte"
    import Pricing from "./routes/pricecalc/Pricing.svelte"
    import ContentFloater from "./widgets/ContentFloater.svelte"
    import SharedOperation from "./routes/SharedOperation.svelte"
    import { icons } from "../config"
    import Bookmarks from "./routes/Bookmarks.svelte"
    import { release } from "../../../api/hooks/config-client"
    import Addresses from "./routes/Addresses.svelte"
    import Carts from "./routes/Carts.svelte"
    import CartButton from "./routes/Carts/CartButton.svelte"
    import Integrations from "./routes/Integrations.svelte"
    import { onMount } from "svelte"
    import Templates from "./routes/Templates.svelte"
    import DateModal from "./widgets/DateModal.svelte"
    import AccountToken from "./routes/AccountToken.svelte"
    import I18nSelect from "./routes/I18nSelect.svelte"
    import OperationLink from "./routes/OperationLink.svelte"
    import { initialLocale } from "../i18n"

    let navopen = false
    let profileopen = false

    let sharedOperationView: boolean = false
    let sharedOperationViewLogoUrl: string

    onMount(() => {
        const updateModalState = () => {
            $openModal = document.getElementsByClassName("dialog-open").length > 0
        }
        const interval = setInterval(updateModalState, 100)
        return () => clearInterval(interval)
    })

    export let url = ""
    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            hash: "",
            push: false,
            pop: false,
        }
    }
    $: {
        if (
            new RegExp(`\/op[o]{0,1}\/[a-zA-Z0-9]*\/[a-zA-Z0-9-]*$`).test($location?.path) ||
            new RegExp(`\/[a-zA-Z0-9]*-endkunden*$`).test($location?.path)
        ) {
            sharedOperationView = true
            console.log("sharedOperationView", sharedOperationView)
            if (!sharedOperationViewLogoUrl) {
                sharedOperationViewLogoUrl = $location?.path
            }
        }
    }

    // scroll to top on new site
    location.subscribe((l) => {
        if (l.push) scrollToTop()
    })

    $: username = $login?.tokenData?.ident
        ? $login.tokenData.ident.dealerNumber + "-" + $login.tokenData.ident.personNumber
        : ""

    if (typeof window !== "undefined") console.log("App initialized")

    // Pin Header
    let scrollY = 0
    let innerHeight = 0
    let outerHeight = 0
    $: if (scrollY) $pageScroll = { scrollY, innerHeight, outerHeight }

    let headerClass = "pin"
    let lastY = 0
    let lastDirection = "up"

    function changeClass(y: number) {
        let result = headerClass
        const scrolledPxs = lastY - y
        const scrollDirection = scrolledPxs < 0 ? "down" : "up"
        const changedDirection = scrollDirection !== lastDirection
        if (changedDirection) {
            result = scrollDirection === "down" ? "unpin" : "pin"
            lastDirection = scrollDirection
        }
        lastY = y
        return result
    }

    $: headerClass = changeClass($pageScroll.scrollY)

    let suNotification
    function suDealer() {
        const dealerNumber = prompt("Händlernummer-Account")
        if (dealerNumber)
            postLogin({ username: dealerNumber })
                .then(() => {
                    newNotification({
                        class: "success",
                        html: $_("notifications.successfulLogout"),
                    })

                    navigateTo("/", { replace: true })
                })
                .catch((e) => {
                    console.log(e)
                    suNotification = newNotification({
                        class: "error",
                        html: $_("notifications.failedLogout"),
                        timeout: 5000,
                        removeOnNewLocation: true,
                    })
                })
    }
</script>

<style lang="less" global>
    @import "./../css/main.less";
</style>

<svelte:window bind:scrollY bind:innerHeight bind:outerHeight />

<header id="header" use:links class="{headerClass}">
    <div class="left">
        {#if !sharedOperationView}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div class="navtrigger" class:active="{navopen}" on:click="{() => (navopen = !navopen)}">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <nav class:active="{navopen}">
                <ul>
                    <li class="seperator-right">
                        <a href="/{initialLocale}" class="light">eInfo</a>
                    </li>
                    <li>
                        <a
                            class:active="{$location.path?.match(/^\/[^\/]+\/operations/)}"
                            href="/{initialLocale}/operations?type=1"
                            use:gotoWithLogin>{$_("header.processInformationSystem")}</a
                        >
                    </li>
                </ul>
            </nav>
        {/if}
        <div class="i18n-mobile">
            <I18nSelect />
        </div>
    </div>
    <div id="logo">
        <a href="{!sharedOperationView ? '/' + initialLocale : sharedOperationViewLogoUrl}">
            <img src="assets/img/renz-logo.png" alt="" />
        </a>
    </div>
    <div class="right">
        <div class="i18n-desktop">
            <I18nSelect />
        </div>
        {#if !sharedOperationView}
            {#if $login}
                <CartButton />
                <button
                    class="btn bookmarks"
                    class:active="{$location.path?.match(/^\/[^\/]+\/bookmarks/)}"
                    class:signify="{checkIfFollowUpEntriesOverdue($followUpMap)}"
                    on:click="{() => {
                        if ($location.path?.match(/^\/[^\/]+\/bookmarks/)) {
                            history.back()
                        } else {
                            navigateTo('/de/bookmarks')
                        }
                    }}"
                >
                    <Icon path="{icons.bookmarkOn}" size="24px" />
                    <span class="text">{$_("header.watchlist")}</span>
                </button>

                <button class="btn logout" on:click="{() => (profileopen = !profileopen)}">
                    <Icon path="{mdiAccountCircle}" size="24px" />
                    <span class="text">{username}</span>
                </button>
                <div
                    class="profile_overlay"
                    class:active="{profileopen}"
                    use:clickOutside="{() => {
                        profileopen = false
                    }}"
                >
                    <div class="profile_top">
                        <Icon path="{mdiAccountCircle}" size="24px" />
                        <span class="innertext"
                            >{$login.account?.firstname || ""}
                            {$login.account?.lastname || ""}</span
                        >
                    </div>
                    {#if $login.account.roles?.includes("A")}
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                        <li
                            data-cy="switch-account"
                            on:click="{() => {
                                suDealer()
                                profileopen = false
                            }}"
                            style="color: #f99"
                        >
                            <Icon path="{mdiAccountArrowLeft}" size="24px" />
                            {$_("header.switchAccount")}
                        </li>
                    {/if}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                    <li
                        data-cy="basedata"
                        on:click="{() => {
                            navigateTo('/de/account-data')
                            profileopen = false
                        }}"
                    >
                        <Icon path="{mdiCardAccountDetailsOutline}" size="24px" />
                        {$_("header.changeMasterData")}
                    </li>
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                    <li
                        data-cy="pwchange"
                        on:click="{() => {
                            navigateTo('/de/account-pw-change')
                            profileopen = false
                        }}"
                    >
                        <Icon path="{mdiLock}" size="24px" />
                        {$_("header.changePassword")}
                    </li>
                    {#if $login?.account.roles?.includes("A") || $login.account.permissions?.includes("T")}
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                        <li
                            data-cy="templates"
                            on:click="{() => {
                                navigateTo('/de/templates')
                                profileopen = false
                            }}"
                        >
                            <Icon path="{mdiFileDocumentEditOutline}" size="24px" />
                            {$_("header.template")}
                        </li>
                    {/if}

                    <!-- svelte-ignore a11y-click-events-have-key-events -->

                    {#if $login?.account.roles?.includes("A") || $login.account.permissions?.includes("C")}
                        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                        <li
                            data-cy="pricecalc"
                            on:click="{() => {
                                navigateTo('/de/pricing')
                                profileopen = false
                            }}"
                        >
                            <Icon path="{mdiCalculator}" size="24px" />
                            {$_("header.priceCalculation")}
                        </li>
                    {/if}

                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    {#if $login?.account.roles?.includes("A") || $login.account.permissions?.includes("B") || $login.account.permissions?.includes("O")}
                        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                        <li
                            data-cy="addresses"
                            on:click="{() => {
                                navigateTo('/de/addresses')
                                profileopen = false
                            }}"
                        >
                            <Icon path="{mdiContacts}" size="24px" />
                            {$_("header.addressBook")}
                        </li>
                    {/if}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    {#if $login?.account.roles?.includes("A") || $login.account.permissions?.includes("L")}
                        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                        <li
                            data-cy="integration"
                            on:click="{() => {
                                navigateTo('/de/integrations')
                                profileopen = false
                            }}"
                        >
                            <Icon path="{mdiViewDay}" size="25px" />
                            {$_("header.integrations")}
                        </li>
                    {/if}
                    {#if $login?.account.roles?.includes("A") || $login.account.permissions?.includes("A")}
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                        <li
                            on:click="{() => {
                                navigateTo('/de/accountToken')
                            }}"
                        >
                            <Icon path="{mdiKey}" size="24px" />
                            {$_("header.token")}
                        </li>
                    {/if}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
                    <li
                        class="logout_link"
                        on:click="{() => {
                            postLogout().then(() => {
                                newNotification({
                                    class: 'success',
                                    html: $_('notifications.successfulLogout'),
                                })
                            })
                            profileopen = false
                        }}"
                    >
                        <Icon path="{mdiLogout}" size="24px" />
                        {$_("header.logout")}
                    </li>
                </div>
            {:else}
                <button
                    class="btn login"
                    on:click="{() => {
                        navigateTo('/de/login')
                    }}"
                >
                    <Icon path="{mdiLogin}" size="24px" />
                    <span class="text"> {$_("header.login")}</span>
                </button>
            {/if}
        {/if}
    </div>
</header>

<div id="site_wrapper" class="  {headerClass == 'pin' ? 'header-visible' : 'header-hidden'}" use:links>
    <Router {url}>
        <Route path="/">
            <Start />
        </Route>
        <Route path="/:lang">
            <Start />
        </Route>
        <Route path="/:lang/login" let:params>
            <Login lang="{params.lang}" />
        </Route>
        <Route path="/:lang/account-pw-reset" let:params>
            <AccountPwReset lang="{params.lang}" />
        </Route>
        <Route path="/:lang/account-request" let:params>
            <AccountRequest lang="{params.lang}" />
        </Route>
        <Route path="/:lang/account-data" let:params>
            <AccountData lang="{params.lang}" />
        </Route>
        <Route path="/:lang/account-pw-change" let:params>
            <AccountPwChange lang="{params.lang}" />
        </Route>
        <Route path="/:lang/account-pw-set" let:params>
            <AccountPwChange lang="{params.lang}" isSetNew />
        </Route>
        <Route path="/:lang/templates" let:params>
            <Templates lang="{params.lang}" />
        </Route>

        <Route path="/:lang/pricing" let:params>
            <Pricing lang="{params.lang}" />
        </Route>
        <Route path="/:lang/addresses" let:params>
            <Addresses lang="{params.lang}" />
        </Route>
        <Route path="/:lang/integrations" let:params>
            <Integrations lang="{params.lang}" />
        </Route>
        <Route path="/:lang/carts" let:params>
            <Carts lang="{params.lang}" />
        </Route>
        <Route path="/:lang/bookmarks" let:params>
            <Bookmarks lang="{params.lang}" />
        </Route>
        <Route path="/:lang/operations" let:params>
            {#key $rerender}
                <Operations lang="{params.lang}" />
            {/key}
        </Route>
        <Route path="/:lang/operations-out" let:params>
            {#key $rerender}
                <OperationsOut lang="{params.lang}" />
            {/key}
        </Route>
        <Route path="/:lang/accountToken" let:params>
            <AccountToken />
        </Route>

        <Route path="/:lang/op/:operation_id/:accessToken" let:params>
            <SharedOperation
                id="{params.operation_id}"
                accessToken="{params.accessToken}"
                collectionName="operation"
            />
        </Route>
        <Route path="/:lang/op/:opNumber" let:params>
            <OperationLink opNumber="{params.opNumber}" lang="{params.lang}" />
        </Route>
        <Route path="/:lang/opo/:operation_id/:accessToken" let:params>
            <SharedOperation
                id="{params.operation_id}"
                accessToken="{params.accessToken}"
                collectionName="operation-out"
            />
        </Route>

        <Route path="/*path" let:params>
            <Content path="/{params.path}" />
        </Route>
    </Router>
</div>

<footer id="footer">
    <div class="container">
        <div class="footernav" use:links>
            <ul>
                <li>
                    <a href="/{initialLocale}/impressum">{$_("header.copyrightPage")}</a>
                </li>
                <li>
                    <a href="{!sharedOperationView ? '/de/datenschutz' : '/de/datenschutz-endkunden'}"
                        >{$_("account.privacyPolicy")}</a
                    >
                </li>
            </ul>
        </div>
    </div>
    {#if $login}
        <div class="version">
            {#if $login.account.roles?.includes("A")}
                <span>access token refresh in {Math.round(($accessTokenExpireSeconds / 60) * 10) / 10 - 1} min / </span>
                <span>logout in {Math.round(($logoutInSeconds / 60) * 10) / 10} min / </span>
            {/if}
            <span>{release.replace(/^.*?\./, "")}</span>
        </div>
    {/if}
</footer>

<Overlay />

<ContentFloater />

<Notifications />
<DateModal />
